"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _react = _interopRequireDefault(require("react"));

var _routesFlippingTiles = _interopRequireDefault(require("../../src/common/components/DrupalTiles/config/routesFlippingTiles"));

var _config = _interopRequireDefault(require("../../config/config"));

var _strings = require("../../config/strings");

var _KESI2Helper = require("../../src/KESI2/KESI2Helper");

var _ActivationCodeHelper = _interopRequireDefault(require("../../src/helpers/ActivationCodeHelper"));

var _FeatureManager = _interopRequireDefault(require("../../src/utils/features/FeatureManager"));

var _DataStore = _interopRequireWildcard(require("../../src/KESI2/Stores/DataStore2"));

var _TeamsLogIn = _interopRequireDefault(require("../../src/common/components/TeamsLogin/TeamsLogIn"));

var kesiExpertFeatureName = 'kesi_expert';

function openActivationCodeDialog(feature) {
  _ActivationCodeHelper["default"].activateForFeature((0, _strings.getString)('UNLOCK_EXPERT_FUNCTIONALITIES_DIALOG_TEXT'), (0, _strings.getString)('UNLOCK_EXPERT_FUNCTIONALITIES_DIALOG_TITLE'), feature, true);
}

var getTileAnimation = function getTileAnimation() {
  var currentValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION) || false;
  console.log('getTileAnimation', currentValue);
  return currentValue === false;
};

var toggleTileAnimation = function toggleTileAnimation() {
  _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION, getTileAnimation());
};

function removeFeature(feature) {
  _FeatureManager["default"].removeFeature(feature);
}

function isNotKesiExpert() {
  return !(0, _KESI2Helper.isKesiExpert)();
}

var _default = (0, _assign["default"])({}, _config["default"], {
  userSelectText: false,
  supportedLanguages: ['de'],
  renderExtraSettingsButtonAboveMainMenuItems: true,
  homeScrollEnabled: false,
  navbarFixed: true,
  showCounter: false,
  showBottomBar: false,
  targetTag: 'eurofh',
  rootId: 'KESI_SPOC_ROOT_EUROFH',
  usesChatNuggets: true,
  cordovaStartUrl: function cordovaStartUrl() {
    return 'kesi2home';
  },
  // cordovaStartUrl: '/kesi2lecture/3',
  targetFeatures: [_routesFlippingTiles["default"]],
  additionalPreconditionActions: [],
  extraSettingsItemsGetter: function extraSettingsItemsGetter() {
    return [{
      condition: isNotKesiExpert,
      label: (0, _strings.getString)('UNLOCK_EXPERT_FUNCTIONALITIES'),
      callback: function callback() {
        return openActivationCodeDialog(kesiExpertFeatureName);
      }
    }, {
      condition: _KESI2Helper.isKesiExpert,
      label: (0, _strings.getString)('LOCK_EXPERT_FUNCTIONALITIES'),
      callback: function callback() {
        return removeFeature(kesiExpertFeatureName);
      }
    }, {
      type: 'switch',
      label: (0, _strings.getString)('TILE_ANIMATION_ACTIVE'),
      onChange: toggleTileAnimation,
      getValue: getTileAnimation,
      listenToPaths: [_DataStore.DATA_STORE_PATHS.KESI_HIDE_TILE_ANIMATION]
    }];
  },
  // eslint-disable-next-line
  isKesiMaster: false,
  // will be set by webpack
  // eslint-disable-next-line
  isKesiSlave: false,
  // will be set by webpack
  showLectureSidebar: false,
  showLectureHeader: true,
  renderExtraSettingsButtonInNavbar: true,
  showHomeButton: false,
  showFilterFavoriteButton: true,
  showFav: true,
  showRead: true,
  sendNavigateMessages: false,
  usesAnalyzer: false,
  sortByOrderField: true,
  showProgressDialogs: true,
  clearStorageOnStart: true,
  showAllDoneDialog: true,
  replaceDrupalLinks: true,
  showNavbarBrowserUserIcon: true,
  showNavbarConnectionsIcon: false,
  loadVisibilities: true,
  defaultUser: 'mobile_equizzer',
  defaultPassword: '!Ye9((UUBpjeu6',
  authClient: 'eurofh_client',
  authClientSecret: '5Nb$eV!AZXrJsBWD%m&DYYtG(x^eq@rk',
  authScopes: 'eCloud:read logAggregate:read logAggregate:write dataStore:read dataStore:write authUser:register',
  defaultNavbarTitle: 'Digital Learning in der Praxis',
  loadingText: 'Lade Lernangebot',
  settingsTitle: 'Mein Konto',
  showUpArrow: true,
  scaleOverlayTiles: 1.0,
  showBackInNavBarInsteadOfCloseButtonForNuggets: true,
  navbarLogo: require('./assets/EuroFH-Logo.png'),
  backendUseBearerAuth: true,
  logSendUrl: 'rest/v1/logentry',
  feedbackRetrieveUrl: 'rest/v1/feedbacks',
  usagesRetrieveUrl: 'rest/v1/usages',
  allContentRetrieveUrl: 'rest/v1/allcontent',
  certificatePdfCreationUrl: 'rest/v1/pdf',
  certificatePdfSendUrl: 'rest/v1/pdf?send=1',
  sortMCFeedback: true,
  ablyApiKey: 'wAkG0g.GZNZoQ:DD595WfdJ2mC8XNN',
  onDataStorePublicDataChangeWebhook: 'rest/api/v1/dataStore/store',
  dataStoreServerUrl: 'rest/api/v1/dataStore/retrieve',
  useCogSettingsIcon: false,
  defaultDataStoreValues: {
    'client.ably.enabled': true,
    'private.hideTileAnimation': true
  },
  useNuggetIconsForLearnState: false,
  resetAppOn401: true,
  mustShowLoading: true,
  showLoadingTimeout: 4500,
  loginComponent: /*#__PURE__*/_react["default"].createElement(_TeamsLogIn["default"], null),
  isLoggedIn: function isLoggedIn(dataToSet) {
    // noinspection UnnecessaryLocalVariableJS
    var isLoggedIn_ = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LOGGED_IN) || _DataStore["default"]._getElementForPath(_DataStore.DATA_STORE_PATHS.LOGGED_IN.split('.'), dataToSet);

    return isLoggedIn_;
  },
  useEurofhLinkId: true,
  ignoreUrlParam: true,
  minBrowser: {
    chrome: 57,
    edge: 0,
    ie: 11,
    firefox: 55,
    safari: 11,
    ios: 10
  }
});

exports["default"] = _default;